import { jsx as a } from "react/jsx-runtime";
import { u as i, e as g } from "./index-6a632112.mjs";
import { s as l } from "./themes-5f0b3c3d.mjs";
import "react";
import { Button as d } from "./button.js";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
const $ = i.span`
  ${(t) => {
  switch (t.$size) {
    case "extra-small":
      return `
      --svg-wrapper-width: ${l["4x"]};
      --svg-wrapper-height: ${l["4x"]};
        `;
    case "small":
      return `
      --svg-wrapper-width: ${l["5x"]};
      --svg-wrapper-height: ${l["5x"]};
      `;
    case "large":
      return `
      --svg-wrapper-width: ${l["8x"]};
      --svg-wrapper-height: ${l["8x"]};
      `;
    case "medium":
    default:
      return `
      --svg-wrapper-width: ${l["6x"]};
      --svg-wrapper-height: ${l["6x"]};
      `;
  }
}};

  --icon-margin: 0;
  width: var(--svg-wrapper-width);
  height: var(--svg-wrapper-height);
  display: flex;

  svg,
  img {
    width: var(--svg-wrapper-width);
    height: var(--svg-wrapper-height);
  }
`, B = i(d)`
  && {
    ${(t) => C(
  t.$iconButtonSize,
  t.theme,
  t.isDisabled,
  t.$iconVariant,
  t.$color
)}
  }
`;
function C(t, o, n, c, u) {
  let r = "", s = "";
  switch (t) {
    case "extra-small":
      s = "2px";
      break;
    case "small":
      s = l["1x"];
      break;
    case "large":
      s = "6px";
      break;
    case "medium":
    default:
      s = "6px";
      break;
  }
  switch (r += `padding: ${s};`, t === "extra-small" && (r += `border-radius : ${l["1x"]}; `), u) {
    case "success":
      n || (c === "primary" ? r += `color: ${o.components.iconButton.textColor};
            background-color: ${o.components.iconButton.colorSuccess};

            &:hover {
              background-color: ${o.components.iconButton.hoverColorSuccess};
              color: ${o.components.iconButton.textColor};
            }
          ` : c === "ghost" ? r += `color: ${o.components.iconButton.colorSuccess};
            background-color: ${o.components.iconButton.bgColor};

            &:hover {
              background-color: ${o.components.iconButton.backgroundColorGhostBlackHover};
              color: ${o.components.iconButton.colorSuccess}
            }
          ` : r += `color: ${o.components.iconButton.colorSuccess};
            background-color: ${o.components.iconButton.bgColor};
            ${c === "secondary" ? `border-color: ${o.components.iconButton.colorSuccess};` : ""}

            &:hover {
              ${c === "secondary" ? `border-color: ${o.components.iconButton.colorSuccess};` : ""}

              background-color: ${o.components.iconButton.secondaryHoverColorSuccess};
              color: ${o.components.iconButton.colorSuccess}
            }
          `);
      break;
    case "oncolor":
      c === "primary" ? (r += `color: ${o.components.iconButton.colorOnColor};
          background-color: ${o.components.iconButton.bgColorOnColor};
          ${n ? "" : `
              &:hover {
                background-color: ${o.components.iconButton.hoverColorOnColor};
                color: ${o.components.iconButton.colorOnColor};
              }`}
        `, n && (r += `color: ${o.components.iconButton.disabledColorOnColor};
            background-color: ${o.components.iconButton.bgDisabledColorOnColor};
          `)) : c === "tertiary" ? (r += `color: ${o.components.iconButton.tertiaryColorOnColor};
          background-color: ${o.components.iconButton.backgroundColorGhostBlack};

          ${n ? "" : `
              &:hover {
                background-color: ${o.components.iconButton.bgSecHoverColorOnColor};
                color: ${o.components.iconButton.tertiaryColorOnColor}
              }`}
        `, n && (r += `color: ${o.components.iconButton.bgTertiaryColorOnColor};
            background-color: ${o.components.iconButton.backgroundColorGhostBlack};
          `)) : (r += `color: ${o.components.iconButton.textColor};
          background-color: ${o.components.iconButton.backgroundColorGhostBlack};
          ${c === "secondary" ? `border-color: ${o.components.iconButton.textColor};` : ""}

          ${n ? "" : `
              &:hover {
                background-color: ${o.components.iconButton.secondaryHoverColorOnColor};
                color: ${o.components.iconButton.textColor};
                ${c === "secondary" ? `border-color: ${o.components.iconButton.textColor};` : ""}
              }`}
        `, n && (r += `color: ${o.components.iconButton.bgTertiaryColorOnColor};
            background-color: ${o.components.iconButton.backgroundColorGhostBlack};
            ${c === "secondary" ? `border-color: ${o.components.iconButton.bgTertiaryColorOnColor};` : ""}
          `));
      break;
    case "danger":
      !n && c === "ghost" && (r += `
          background-color: ${o.components.iconButton.bgColor};

          &:hover {
            background-color: ${o.components.iconButton.backgroundColorGhostBlackHover};
          }
        `);
      break;
    default:
      n || (c === "secondary" || c === "tertiary" ? r += `
          color: ${o.components.iconButton.primaryTextColor};

          &:hover {
            color: ${o.components.iconButton.primaryTextColor};
          }
        ` : c === "ghost" && (r += `
          background-color: ${o.components.iconButton.bgColor};
          color: ${o.components.iconButton.textColorGhostBlack};

          &:hover {
            background-color: ${o.components.iconButton.backgroundColorGhostBlackHover};
            color: ${o.components.iconButton.textColorGhostBlack};
          }
        `));
      break;
  }
  return r;
}
const O = ({
  size: t = "medium",
  color: o = "default",
  variant: n = "primary",
  icon: c,
  isDisabled: u = !1,
  accessibilityOptions: r,
  ...s
}) => {
  const p = g();
  let e;
  return n === "tertiary" || n === "ghost" ? e = "text" : n === "secondary" ? e = "outline" : e = n, /* @__PURE__ */ a(
    B,
    {
      $iconButtonSize: t,
      variant: e,
      $iconVariant: n,
      isDisabled: u,
      theme: p,
      color: o === "danger" ? "destructive" : "primary",
      $color: o,
      ...s,
      accessibilityOptions: r,
      children: /* @__PURE__ */ a($, { $size: t, "aria-hidden": "true", children: c })
    }
  );
};
export {
  O as IconButton
};
